export enum GameActions {
  CreateGame = 'createGame',
  UpdateGame = 'updateGame',
  GetGame = 'getGame',
  ListGames = 'listGames',
  DeleteGame = 'deleteGame',
}
